import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiaApi from '../../../api/apiaApi/apiaApi';
import { notify } from '../../../components/common/notifications/util';
import { makeGridActionUrl } from '../actionsUtils';
import { TApiaXMLResponse, TDataGridThunkState } from '../types';
import { shouldDebugGridActions } from './add';
import { TRowActionResponse } from './types';

const clearPage = createAsyncThunk<
  TRowActionResponse | null,
  {
    gridId: string;
    page: number;
  },
  TDataGridThunkState
>('dataGridSlice/clearPage', async ({ gridId, page }, thunkApi) => {
  const state = thunkApi.getState().dataGridSlice[gridId];
  const result = await ApiaApi.post<TApiaXMLResponse>(
    makeGridActionUrl({
      gridAction: 'clearPage',
      context: state.context,
      page,
    }),
  );
  if (shouldDebugGridActions) console.log('clearPage', result?.data);
  if (result?.data)
    return {
      xmlResponse: result?.data,
      focusRow: state.focusedRow,
      newSelectedRows: state.selectedRows,
      focusColumn: state.focusedColumn,
    };

  notify({
    message: 'Error on DataGrid action',
    type: 'danger',
  });
  return null;
});

export default clearPage;
